(function () {
  'use strict';

  // Mobile carousels: keep the dot indicator in sync with the scroll position.
  function initCarousel(track) {
    var dots = document.querySelector('[data-u-dots="' + track.id + '"]');
    if (!dots || track.dataset.uReady) return;
    track.dataset.uReady = 'true';
    var slides = Array.prototype.slice.call(track.children);
    var buttons = Array.prototype.slice.call(dots.querySelectorAll('button'));

    function setActive(index) {
      buttons.forEach(function (b, i) { b.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }

    buttons.forEach(function (button, i) {
      button.addEventListener('click', function () {
        track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      });
    });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var maxScroll = track.scrollWidth - track.clientWidth;
        if (maxScroll > 0 && track.scrollLeft >= maxScroll - 4) return setActive(slides.length - 1);
        var origin = slides[0].offsetLeft;
        var best = 0;
        slides.forEach(function (s, i) {
          if (Math.abs(s.offsetLeft - origin - track.scrollLeft) < Math.abs(slides[best].offsetLeft - origin - track.scrollLeft)) best = i;
        });
        setActive(best);
      });
    }, { passive: true });
  }

  // Mobile menu
  function initMenu(root) {
    var menu = root.querySelector('[data-u-menu]');
    if (!menu || menu.dataset.uReady) return;
    menu.dataset.uReady = 'true';
    var openers = root.querySelectorAll('[data-u-menu-open]');
    var closers = menu.querySelectorAll('[data-u-menu-close]');

    function toggle(open) {
      menu.setAttribute('data-open', open ? 'true' : 'false');
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      openers.forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      if (open) { var first = menu.querySelector('button, a'); if (first) first.focus(); }
    }

    openers.forEach(function (b) { b.addEventListener('click', function () { toggle(true); }); });
    closers.forEach(function (b) { b.addEventListener('click', function () { toggle(false); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menu.getAttribute('data-open') === 'true') toggle(false);
    });
  }

  // Cart count bubble refresh after AJAX cart updates
  function refreshCount() {
    var bubbles = document.querySelectorAll('[data-u-cart-count]');
    if (!bubbles.length) return;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        bubbles.forEach(function (b) { b.textContent = cart.item_count > 0 ? cart.item_count : ''; });
      })
      .catch(function () {});
  }


  // Product gallery arrows
  function initGallery(root) {
    var track = root.querySelector('[data-u-gallery]');
    if (!track || track.dataset.uArrows) return;
    track.dataset.uArrows = 'true';
    var prev = root.querySelector('[data-u-gallery-prev]');
    var next = root.querySelector('[data-u-gallery-next]');
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    function go(dir) { track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
    update();
  }

  // Kit builder: pack (variant) + scent mix (line item properties) + optional selling plan
  function initKitForm(form) {
    if (form.dataset.uReady) return;
    form.dataset.uReady = 'true';
    var section = form.closest('[data-u-pdp]');
    var strings = {};
    try { strings = JSON.parse(section.querySelector('[data-u-strings]').textContent); } catch (e) {}
    var packs = Array.prototype.slice.call(form.querySelectorAll('.u-pack__input'));
    var scents = Array.prototype.slice.call(form.querySelectorAll('[data-u-scent]'));
    var variantInput = form.querySelector('[data-u-variant-input]');
    var planInput = form.querySelector('[data-u-plan-input]');
    var picked = form.querySelector('[data-u-picked]');
    var submit = form.querySelector('[data-u-submit]');
    var label = form.querySelector('[data-u-cta-label]');
    var error = form.querySelector('[data-u-error]');
    var state = { target: 0, counts: scents.map(function () { return 0; }), pack: null };

    function total() { return state.counts.reduce(function (a, b) { return a + b; }, 0); }

    function mixFor(input) {
      var target = parseInt(input.dataset.bars, 10) || 0;
      var mix = (input.dataset.mix || '').split(',').map(function (n) { return parseInt(n, 10) || 0; });
      var sum = mix.reduce(function (a, b) { return a + b; }, 0);
      if (mix.length !== scents.length || sum !== target) {
        mix = scents.map(function (_, i) { return Math.floor(target / scents.length) + (i < target % scents.length ? 1 : 0); });
      }
      return mix;
    }

    function selectPack(input) {
      state.pack = input;
      state.target = parseInt(input.dataset.bars, 10) || 0;
      state.counts = scents.length ? mixFor(input) : [];
      variantInput.value = input.value;
      if (planInput) {
        planInput.value = input.dataset.plan || '';
        planInput.disabled = !input.dataset.plan;
      }
      packs.forEach(function (p) { p.closest('.u-pack').classList.toggle('is-selected', p === input); });
      render();
    }

    function render() {
      var t = total();
      scents.forEach(function (row, i) {
        var c = state.counts[i] || 0;
        row.querySelector('[data-u-count]').textContent = c;
        var hidden = row.querySelector('[data-u-scent-input]');
        hidden.value = c;
        hidden.disabled = c === 0;
        row.classList.toggle('is-active', c > 0);
        row.querySelector('[data-u-step="-1"]').disabled = c === 0;
        row.querySelector('[data-u-step="1"]').disabled = t >= state.target;
      });
      if (picked) {
        picked.textContent = (strings.picked || '[count] / [total] picked').replace('[count]', t).replace('[total]', state.target);
        picked.classList.toggle('is-incomplete', scents.length > 0 && t !== state.target);
      }
      var pack = state.pack;
      var unavailable = !pack || !pack.value || pack.hasAttribute('data-unavailable');
      var missing = scents.length ? state.target - t : 0;
      if (unavailable) {
        label.textContent = strings.unavailable || 'Sold out';
      } else if (missing > 0) {
        label.textContent = (strings.pickMore || 'Pick [count] more').replace('[count]', missing);
      } else {
        label.textContent = (strings.cta || 'Add to cart · [price]').replace('[price]', pack.dataset.price || '');
      }
      submit.disabled = unavailable || missing !== 0;
    }

    packs.forEach(function (input) {
      input.addEventListener('change', function () { if (input.checked) selectPack(input); });
    });

    scents.forEach(function (row, i) {
      row.querySelectorAll('[data-u-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.dataset.uStep, 10);
          var next = (state.counts[i] || 0) + step;
          if (next < 0 || (step > 0 && total() >= state.target)) return;
          state.counts[i] = next;
          render();
        });
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submit.disabled) return;
      error.hidden = true;
      submit.setAttribute('aria-busy', 'true');
      var data = new FormData(form);
      packs.forEach(function (p) { data.delete(p.name); });
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || strings.error);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: res.json } }));
          var drawerEvent = new CustomEvent('uncle:cart-open', { cancelable: true });
          if (document.dispatchEvent(drawerEvent)) window.location.href = form.dataset.cartUrl || '/cart';
        })
        .catch(function (err) {
          error.textContent = err.message || strings.error;
          error.hidden = false;
        })
        .finally(function () { submit.removeAttribute('aria-busy'); });
    });

    var initial = packs.filter(function (p) { return p.checked; })[0] || packs[0];
    if (initial) { initial.checked = true; selectPack(initial); }
  }


  // Side cart: server-rendered with the Section Rendering API, refreshed after every cart change
  var cartRoot = function () { return (window.Shopify && Shopify.routes ? Shopify.routes.root : '/'); };
  var lastFocus = null;

  function cartEl() { return document.querySelector('[data-u-cart]'); }

  function openCart() {
    var el = cartEl();
    if (!el) return;
    lastFocus = document.activeElement;
    el.setAttribute('data-open', 'true');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var drawer = el.querySelector('.u-cart__drawer');
    if (drawer) drawer.focus();
  }

  function closeCart() {
    var el = cartEl();
    if (!el) return;
    el.setAttribute('data-open', 'false');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function renderCart() {
    return fetch(cartRoot() + '?sections=uncle-cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data['uncle-cart-drawer'];
        var el = cartEl();
        if (!html || !el) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-u-cart-inner]');
        var current = el.querySelector('[data-u-cart-inner]');
        if (fresh && current) current.replaceWith(fresh);
        refreshCount();
      });
  }

  function cartRequest(path, body) {
    var el = cartEl();
    if (el) el.setAttribute('aria-busy', 'true');
    return fetch(cartRoot() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (json) { if (!r.ok) throw new Error(json.description || json.message); return json; }); })
      .then(renderCart)
      .catch(function (err) { window.alert(err.message || 'Something went wrong.'); })
      .finally(function () { if (el) el.removeAttribute('aria-busy'); });
  }

  function initCart() {
    var el = cartEl();
    if (!el || el.dataset.uReady) return;
    el.dataset.uReady = 'true';

    el.addEventListener('click', function (e) {
      var t = e.target.closest('button, [data-u-cart-close]');
      if (!t) return;
      if (t.hasAttribute('data-u-cart-close')) return closeCart();
      if (t.hasAttribute('data-u-cart-remove')) return cartRequest('cart/change.js', { line: parseInt(t.getAttribute('data-u-cart-remove'), 10), quantity: 0 });
      if (t.hasAttribute('data-u-cart-add')) return cartRequest('cart/add.js', { items: [{ id: parseInt(t.getAttribute('data-u-cart-add'), 10), quantity: 1 }] });
      if (t.hasAttribute('data-u-cart-upgrade')) {
        var props = {};
        try { props = JSON.parse(t.dataset.props || '{}'); } catch (err) {}
        Object.keys(props).forEach(function (k) { if (props[k] === '0' || props[k] === '') delete props[k]; });
        var item = { id: parseInt(t.dataset.id, 10), quantity: 1, properties: props };
        if (t.dataset.plan) item.selling_plan = parseInt(t.dataset.plan, 10);
        t.disabled = true;
        return fetch(cartRoot() + 'cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ line: parseInt(t.dataset.line, 10), quantity: 0 })
        }).then(function () { return cartRequest('cart/add.js', { items: [item] }); });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el.getAttribute('data-open') === 'true') closeCart();
    });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-u-cart-open]');
      if (!trigger) return;
      e.preventDefault();
      renderCart().then(openCart);
      openCart();
    });

    // Product form asks for the drawer after an add: refresh it and keep the shopper on the page
    document.addEventListener('uncle:cart-open', function (e) {
      e.preventDefault();
      renderCart().then(openCart);
    });
  }


  // FAQ page: highlight the category in view, keep the active tab visible
  function initFaqPage(root) {
    if (root.dataset.uReady) return;
    root.dataset.uReady = 'true';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-u-faqp-tab]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-u-faqp-group]'));
    if (!('IntersectionObserver' in window) || !groups.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        tabs.forEach(function (t) {
          var active = t.getAttribute('href') === '#' + entry.target.id;
          t.classList.toggle('is-active', active);
          if (active && t.parentElement.scrollWidth > t.parentElement.clientWidth) {
            t.parentElement.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
          }
        });
      });
    }, { rootMargin: '-30% 0px -60% 0px' });
    groups.forEach(function (g) { io.observe(g); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-u-carousel]').forEach(initCarousel);
    (scope || document).querySelectorAll('[data-u-header]').forEach(initMenu);
    (scope || document).querySelectorAll('[data-u-pdp]').forEach(initGallery);
    (scope || document).querySelectorAll('[data-u-kit-form]').forEach(initKitForm);
    initCart();
    (scope || document).querySelectorAll('[data-u-faqp]').forEach(initFaqPage);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('cart:updated', refreshCount);
  document.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
})();
